import RoundLoader from "./roundLoader.gif";

function Loader() {
  return (
    <div>
      <img src={RoundLoader} height="200px" alt="Loading..."/>
    </div>
  );
}

export default Loader;
